import { render, staticRenderFns } from "./PipelineDetailsModal.vue?vue&type=template&id=36d61891"
import script from "./PipelineDetailsModal.vue?vue&type=script&lang=js"
export * from "./PipelineDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports